export default __webpack_public_path__ + "static/media/demon-avenger.62defd19.png";